/* global WP */

const $ = jQuery.noConflict();
import 'slick-carousel';

const initRelatedPeopleBlocks = () => {
	const relatedPeopleBlocksObjects = [];
	const relatedPeopleBlocks = document.querySelectorAll(
		'.block-people-related'
	);

	if (relatedPeopleBlocks.length) {
		relatedPeopleBlocks.forEach((block, index) => {
			const loadMoreButton = block.querySelector(
				'.block-people-related__view-more'
			);

			// If there is no load more button, we don't need to set this up
			if (!loadMoreButton) return;

			const peopleGrid = block.querySelector(
				'.block-people-related__grid'
			);
			const practiceCodeIDs = loadMoreButton.getAttribute(
				'data-practice-code-ids'
			);
			const selectedPeopleIDs =
				loadMoreButton.getAttribute('data-selected-ids');
			const isNarrow = loadMoreButton.getAttribute('data-is-narrow');
			const nonce = loadMoreButton.getAttribute('data-security-nonce');

			relatedPeopleBlocksObjects[index] = {
				element: block,
				loadMoreButton,
				peopleGrid,
				isNarrow,
				page: 1,
				perPage: loadMoreButton.getAttribute('data-per-page'),
				practiceCodeIDs,
				selectedPeopleIDs,
				nonce,
			};

			loadMoreButton.addEventListener('click', async (e) => {
				e.preventDefault();
				loadMoreButton.disabled = true;
				await loadMorePeople(relatedPeopleBlocksObjects[index]);
				loadMoreButton.disabled = false;
			});
		});
	}
};

function loadMorePeople(blockObject) {
	const {
		page,
		perPage,
		peopleGrid,
		loadMoreButton,
		practiceCodeIDs,
		selectedPeopleIDs,
		isNarrow,
		nonce,
	} = blockObject;
	const data = new FormData();
	data.append('action', 'load_more_people');
	data.append('page', page);
	data.append('perPage', perPage);
	data.append('practiceCodeIDs', practiceCodeIDs);
	data.append('selectedPeopleIDs', selectedPeopleIDs);
	data.append('isNarrow', isNarrow);
	data.append('security', nonce);
	const params = new URLSearchParams(data);

	return new Promise((resolve, reject) => {
		fetch(WP.ajaxUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache',
			},
			credentials: 'same-origin',
			body: params,
		})
			.then((response) => {
				// console.log(response);
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((json) => {
				// console.log(json);
				const { maxNumPages, html, currentPage } = json;

				// peopleGrid.innerHTML += html;
				$(peopleGrid).append(html);

				blockObject.page++;

				// If we're on the last page, disable the load more button
				if (maxNumPages === currentPage) {
					loadMoreButton.classList.add('disabled');
				}

				resolve();
			})
			.catch((error) => {
				console.log(error); // eslint-disable-line no-console
				reject(error);
			});
	});
}

const controller = {
	init() {
		initRelatedPeopleBlocks();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
